
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.017 8.952a4.518 4.518 0 01-2.16-2.011 3 3 0 003.096 5.104 4.315 4.315 0 01-.936-3.093zm1.316.354v.027c0 .715.25 1.37.667 1.886a2.988 2.988 0 00.666-1.962 4.526 4.526 0 01-1.333.049zM7 12.986a4.333 4.333 0 11-4.595-7.349 4.5 4.5 0 118.884-.17A4.333 4.333 0 117 12.984zm3.896-6.214a3 3 0 01-2.848 5.273 4.315 4.315 0 00.92-3.249 4.519 4.519 0 001.928-2.024zM9.993 5.05a3.167 3.167 0 10-6.314.063A4.346 4.346 0 017 5.681a4.313 4.313 0 012.993-.631zM8.047 6.622a2.988 2.988 0 011.569-.276 3.182 3.182 0 01-1.034 1.128 4.335 4.335 0 00-.535-.852zM7 7.448c.128.158.24.33.335.513a3.19 3.19 0 01-.687.034c.098-.196.216-.38.352-.547zm-1.047-.826c-.245.305-.45.644-.606 1.008a3.182 3.182 0 01-1.271-1.238 3.015 3.015 0 011.877.23z"}})])
          )
        }
      }
    